module.exports = __webpack_public_path__ + "static/media/remiLorrain.09ee66c8.png";